class AnimatedSearchText extends HTMLElement {
  constructor() {
    super();

    this.typewriterElement = this.querySelector('[data-animated-search-text-el="typewriter"]');
    this.typewriterTexts = this.getAttribute('data-content').split(',').map(item => item.trim());

    this.typewriterSpeed = 150;
    this.typewriterDeleteSpeed = 100;
    this.typewriterPauseDuration = 1000;
    this.typewriterCurrentTextIndex = 0;
    this.typewriterCurrentCharIndex = 0;
    this.typewriterIsDeleting = false;
    this.typerwriterIsStopped = true;
    this.typewriterTimeoutId = null;

    this.startTyping();
  }

  startTyping() {
    if (this.typerwriterIsStopped) {
      this.typerwriterIsStopped = false;
      this.type();
    }
  }

  type () {
    if (this.typewriterTexts.length) {
      const currentText = this.typewriterTexts[this.typewriterCurrentTextIndex];
      let displayText = currentText.substring(0, this.typewriterCurrentCharIndex);
      this.typewriterElement.textContent = displayText;

      if (!this.typewriterIsDeleting && this.typewriterCurrentCharIndex < currentText.length) {
        this.typewriterCurrentCharIndex++;
        this.typewriterTimeoutId = setTimeout(() => this.type(), this.typewriterSpeed);

      } else if (this.typewriterIsDeleting && this.typewriterCurrentCharIndex > 0) {
        this.typewriterCurrentCharIndex--;
        this.typewriterTimeoutId = setTimeout(() => this.type(), this.typewriterDeleteSpeed);

      } else {
        this.typewriterIsDeleting = !this.typewriterIsDeleting;

        if (!this.typewriterIsDeleting) {
          this.typewriterCurrentTextIndex = (this.typewriterCurrentTextIndex + 1) % this.typewriterTexts.length;
        }

         this.typewriterTimeoutId = setTimeout(() => this.type(), this.typewriterPauseDuration);
      }
    }
  }
}

customElements.define('animated-search-text', AnimatedSearchText)
